/**
 * @generated SignedSource<<b031666779efbb82bc1f16262666d990>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FilterRefinement$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AssigneePicker">;
  readonly " $fragmentType": "FilterRefinement";
};
export type FilterRefinement$key = {
  readonly " $data"?: FilterRefinement$data;
  readonly " $fragmentSpreads": FragmentRefs<"FilterRefinement">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": 100,
      "kind": "LocalArgument",
      "name": "assignees"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "scope"
    }
  ],
  "kind": "Fragment",
  "name": "FilterRefinement",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "assignees",
          "variableName": "assignees"
        },
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Variable",
          "name": "scope",
          "variableName": "scope"
        }
      ],
      "kind": "FragmentSpread",
      "name": "AssigneePicker"
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "02f81acf6b8e41a5d4c293b90222190f";

export default node;
